export const baseOrder = {
	order_id: "",
	business_id: "",
	estate_parent_id: "",
	estate_id: "",
	dealer_id: "",
	rut_dealer: "",
	classification_id: "",
	type_currency_id: "",
	code_oc: "",
	petitioner_id: "",
	date_order: "",
	date_create_order: "",
	observations: "",
	state_id: 1,
	items: [],
	documents: [],
	contact: "",
};

export const customStyles = {
	control: (base, state) => ({
		...base,
		background: "#f3f3f3",
		border: "none",
		height: "1px",
		boxShadow: state.isFocused ? null : null,
	}),
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
};

export const baseUnitCreate = [
	{
		value: "u1",
		label: "Un",
	},
	{
		value: "c1",
		label: "cc",
	},
	{
		value: "c1000",
		label: "L",
	},
	{
		value: "g1",
		label: "g",
	},
	{
		value: "g1000",
		label: "Kg",
	},
	{
		value: "g1000000",
		label: "Tn",
	},
];
